<template>
  <div class="container mx-auto flex flex-col">
    <div class="app-content-back">
      <div
        v-if="item"
        class="p-8"
      >
        <div class="mb-8 section-title">
          {{ item.name }}
        </div>

        <sc-difficulty :difficulty="item.difficulty" />
        <div v-if="item.description">
          {{ item.description }}
        </div>
      </div>

      <div v-if="functionalAllowed && item.links && item.links.length>0">
        <div
          v-if="item.links && item.links.length>0"
          class="flex flex-col text-xs mb-2"
        >
          <div
            v-for="link in item.links"
            :key="link.url"
            class="flex justify-center"
          >
            <iframe
              v-if="link.kind==6"
              id="vmplayer"
              :src="buildVimeoLink(link)"
              width="640"
              height="365"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
            />
            <iframe
              v-if="link.kind==7"
              id="ytplayer"
              type="text/html"
              width="640"
              height="360"
              :src="buildYoutubeLink(link)"
              frameborder="0"
            />

            <iframe
              v-if="link.kind==8"
              :src="buildgDriveLink(link)"
              width="640"
              height="360"
            />
          </div>
          <div>
            Übungen:
          </div>
        </div>
      </div>
      <div
        v-else
        class="lg:m-10"
      >
        <pv-panel header="Externe Medien" v-if="item.links && item.links.length>0">
          <div class="w-full">
            <div
              v-if="item.medias && item.medias.length>0"
              class="flex flex-col text-xs mb-2"
            >
              <div
                v-for="link in item.medias"
                :key="link.url"
                class="flex justify-start"
              >
                <a
                  :href="link.url"
                  target="_blank"
                >
                  {{ link.url }}
                </a>
              </div>
            </div>
          </div>
          <contentConsent consent-name="Funktionale" />
        </pv-panel>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'
import contentConsent from '../cookies/contentConsent'

export default {

    name: 'MasteriesDetail',
  components: { contentConsent },
    data () {
        return {
            id: '',
            isBusy: false,
            item: null,
            assetPosition: 0,
            functionalAllowed: false
        }
    },
    async mounted () {
        const cookie = this.$cookies.get('cookiefirst-consent')
        const functional = cookie && cookie.functional
        this.functionalAllowed = functional
        this.id = this.key = this.$route.params.id
        await this.read(this.id)
    },
    methods: {
        async read (id) {
            const response = await apiService.getMasteryById(id)
            this.item = response.data
        },
        setAsset (index) {
            this.assetPosition = index
        },
        buildYoutubeLink (link) {
            // TODO extract to api
            const src = 'https://www.youtube.com/embed/' + link.value
            return src
        },

        buildVimeoLink (link) {
            return 'https://player.vimeo.com/video/' + link.value
        },

        buildgDriveLink (link) {
            return 'https://drive.google.com/file/d/' + link.value + '/preview'
        }
    }
}
</script>

<style scoped>

</style>
